import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, map } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

@Injectable({ providedIn: 'root' })
export class ApiService {
    public project = 'hklsc_pthyxs';
    constructor(private http: HttpClient) {
        let host = location.href;
        if (host.includes('ccec')){
            this.project = 'hklsc_ccec';
        }
    }

    getSchoolList(): Observable<any[]> {
        if (this.project === 'hklsc_ccec') {
            // 同時讀取兩個 JSON，然後合併
            return forkJoin([
            this.http.get<any[]>('/assets/hkschool-primary-secondary-with-sen-list.json'),
            this.http.get<any[]>('/assets/hkschool-kindergarden-with-sen-list.json')
            ]).pipe(
            map(([primarySecondaryList, kindergartenList]) => {
                // 合併兩個陣列
                return [...primarySecondaryList, ...kindergartenList];
            })
            );
        }

        // 非 hklsc_ccec 專案，只返回中小學
        return this.http.get<any[]>('/assets/hkschool-primary-secondary-with-sen-list.json');
    }

    postRegistration(data: any): Observable<any> {
        let payload = {
            loginDomain: data.loginDomain,
            school_id: parseInt(data.school_id),
            tag_id: parseInt(data.tag_id),
            email: data.email,
            phone: data.phone,
            password: data.password,
            origin: data.origin,
            first_name: data.first_name,
            last_name: data.last_name,
            affiliation: data.affiliation,
            agree_marketing: data.agree_marketing,
            reg_from: this.project
        };
        return this.roWebPost('ROOnlineShopUser.POST_create_teacher_account', [payload]);
    }

    verifyTeacherEmail(body: any): Observable<any> {
        return this.roWebPost('ROOnlineShopUser.PUT_create_teacher_account', [body]);
    }

    roWebPost(api: string, data: any[] = [{}], options: any = {}): Observable<any> {
        let roWebApiUrl = '//{host}/RainbowOne/index.php/PHPGateway/proxy/2.8/';
        let host = location.hostname;
        if (location.port != ''){
            host = 'dev.openknowledge.hk';
        }
        roWebApiUrl = roWebApiUrl.replace('{host}', host);
        let apiData:any = {};
        apiData.api = api;
        apiData.json = JSON.stringify(data);
        apiData.appId = 'hklsc';
        apiData.lang = 'tc';
        return this.http.post(roWebApiUrl, apiData, options);
    }

    // Admin API methods
    adminLogin(email: string, password: string): Observable<any> {
        let token = uuidv4();
        let payload = {
            email,
            loginDomain: 'hklsc',
            password,
            school_id: 69199,
            tag_id: 70831,
            token,
            deviceType: 'cwcProxyAPIServer'
        };
        return this.roWebPost('ROOnlineShopUser.POST_login', [payload]);
    }

    getAdminAccounts(token: string): Observable<any> {
        let payload =  { loginDomain: 'hklsc', school_id: 69199, reg_from: this.project };
        // let payload =  { loginDomain: 'hklsc', school_id: 69199 };
        let options = {
            headers: { Authorization: `Bearer ${token}` }
        };
        const api1$ = this.roWebPost('ROOnlineShopUser.GET_approved_teacher_accounts', [ payload ], options);
        const api2$ = this.roWebPost('ROOnlineShopUser.GET_verified_pending_approve_teacher_accounts', [ payload ], options);

        return forkJoin({
            approved: api1$,
            pending: api2$
        }).pipe(map(({approved, pending}) => ({
            data: {
                approved_accounts: approved.data.approved_accounts ?? [],
                pending_accounts: pending.data.pending_accounts ?? []
            }
        }) ) );
    }

    approveAccount(uuid: string, token: string): Observable<any> {
        return this.roWebPost('ROOnlineShopUser.PUT_approve_teacher_account_creation', [{
            loginDomain: 'hklsc',
            school_id: 69199,
            uuid
        }],{
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    }

    rejectAccount(uuid: string, rejectionReason: string, token: string): Observable<any> {
        const requestData: any = {
            loginDomain: 'hklsc',
            school_id: 69199,
            uuid
        };

        if (rejectionReason && rejectionReason.trim()) {
            requestData.rejection_reason = rejectionReason.trim();
        }
        return this.roWebPost('ROOnlineShopUser.POST_account_reject', [{
            loginDomain: 'hklsc',
            school_id: 69199,
            uuid
        }],{
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
/*
        return this.http.post<any>(`${this.apiUrl}cwc/admin/account-reject`, requestData, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).toPromise();*/
    }
}
